// src/components/scheduler/TimeSlotPicker.tsx
import React from 'react';

interface TimeSlotPickerProps {
    slots: string[];
    selectedTime: string | null;
    onTimeSelect: (time: string) => void;
}

export const TimeSlotPicker: React.FC<TimeSlotPickerProps> = ({
    slots,
    selectedTime,
    onTimeSelect
}) => {
    return (
        <div className="bg-white border border-gray-200 rounded-lg p-3 max-h-80 overflow-y-auto">
            <div className="grid grid-cols-3 gap-2">
                {slots.map((slot) => (
                    <button
                        key={slot}
                        onClick={() => onTimeSelect(slot)}
                        className={`
              px-3 py-2 rounded-md text-sm font-medium transition-all duration-200
              ${selectedTime === slot
                                ? 'bg-[#212A37] text-white'
                                : 'bg-gray-100 hover:bg-gray-200 text-gray-700 border border-gray-300'
                            }
            `}
                    >
                        {slot}
                    </button>
                ))}
            </div>

            {slots.length === 0 && (
                <p className="text-center text-gray-500 py-8">
                    No time slots available for this date
                </p>
            )}
        </div>
    );
};